"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NetworkStatistics {
    constructor() {
        this.time = new Date();
        this.nrOfActiveWatchers = 0;
        this.nrOfActiveValidators = 0; //validators that are validating
        this.nrOfActiveFullValidators = 0;
        this.nrOfActiveOrganizations = 0;
        this.transitiveQuorumSetSize = 0;
        this.hasTransitiveQuorumSet = false;
        this.minBlockingSetFilteredSize = 0;
    }
    static fromJSON(networkStats) {
        let networkStatsObject;
        if (typeof networkStats === 'string') {
            networkStatsObject = JSON.parse(networkStats);
        }
        else
            networkStatsObject = networkStats;
        let newNetworkStatistics = new NetworkStatistics();
        for (const [key, value] of Object.entries(networkStatsObject)) {
            if (key === 'time') {
                //@ts-ignore
                newNetworkStatistics.time = new Date(value);
            }
            else {
                //@ts-ignore
                newNetworkStatistics[key] = value;
            }
        }
        return newNetworkStatistics;
    }
}
exports.default = NetworkStatistics;
//# sourceMappingURL=network-statistics.js.map